import { AppBar, Card, Autocomplete, CardContent, FormHelperText, Dialog, DialogContent, Box, Button, CssBaseline, alpha, Toolbar, Divider, Menu, MenuItem, ListItemText, FormControl, Grid, Checkbox, IconButton, LinearProgress, Modal, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography, useTheme, TableContainer } from "@mui/material"
import CustomSnackbar from "../../../components/CustomSnackbar"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers-pro"
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox"
import CustomTableContainer from "../../../components/table/CustomTableContainer"
import { tokens } from "../../../theme/theme"

import dayjs from "dayjs"
import React, { useState, useEffect } from "react"
import GlobalConfig from "../../../components/GlobalConfig"
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { API_ENDPOINTS } from "../../../config/api/apiCall"
import axios from "axios"
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

// icons
import AddIcon from '@mui/icons-material/Add';
import CancelIcon from '@mui/icons-material/Close';
import ScheduleIcon from '@mui/icons-material/Schedule';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import Amendicon from '@mui/icons-material/AutorenewOutlined';
import CancelIcon1 from '@mui/icons-material/Cancel';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import List from '@mui/icons-material/List';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchIcon from "@mui/icons-material/Search";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { ListItemIcon } from "@mui/material";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import Close from '@mui/icons-material/Close';
import HelpIcon from '@mui/icons-material/HelpOutline';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';

import { styled } from '@mui/system';
import DateRangePicker from "../../../components/DateRangePicker"
import DespatchActionMenu from "./despatchActionMenu"
import DispatchPlanReport from "../../reports/salesManagement/DispatchPlanReport"

import ConfirmationOrderItems from "./ConfirmationOrderItems"
import PlannedQtySummaryCard from "./PlannedQtySummaryCard"
import COActionMenu from "./COActionMenu"
import CODetailFilter from "./CODetailFilter"
import useCOAvailableGForDespatchPlan from "../../../hooks/salesorder/despatch.js/useCOAvailableGForDespatchPlan"
import TableFilterRow from "../../../components/table/TableFilterRow"
import CustomPagination from "../../../components/table/CustomPagination"

const CreateDispatch = ({ handleBackTofromConnfrimOrderList, selectedRow, handleCallBack }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // const [fromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    // const [toDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [errorMessage, setErrorMessage] = useState('');
    const [FromCODate, setFromCODate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToCODate, setToCODate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [orderDate, setOrderDate] = useState(dayjs());
    const [scheduleDate, setScheduleDate] = useState(dayjs());

    const [remarks, SetRemarks] = useState('');
    const [viewDispatchPlan, setisViewDispatchPlan] = useState(true);
    const [viewCreateDispatchPlan, setViewCreateDispatchPlan] = useState(true);
    const [viewCreateDispatchPlanEntry, setviewCreateDispatchPlanEntry] = useState(false);
    const [viewDispatchItem, setviewDispatchItem] = useState(false);
    const [isVisible_commanButtons, setisVisible_commanButtons] = useState(false);
    const [isVisible_cancelDetail, setisVisible_cancelDetail] = useState(false);

    const [isVisiblebtnCreateDespatchPlan, setisVisiblebtnCreateDespatchPlan] = useState(true);
    const [isVisiblebtnAddSelectedCO, setisVisiblebtnAddSelectedCO] = useState(false);

    const [isVisibleReelItem, setisVisibleReelItem] = useState(false);
    const [isVisibleSheetItem, setisVisibleSheetItem] = useState(false);

    const [fromModule, SetfromModule] = useState('');
    const [fromSubModule, SetfromSubModule] = useState('');
    const [headerDespatchplan, SetheaderDespatchplan] = useState('New Despatch Plan');

    const [btnApprove, setbtnApprove] = useState(false);
    const [btnSaveUpdate, setbtnSaveUpdateOrdershow] = useState(false);
    const [btnAmendment, setbtnAmendmentshow] = useState(false);
    const [btnPrint, setbtnPrint] = useState(false);
    const [btnCancel, setbtnCancel] = useState(false);

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertsevierity, setalertsevierity] = useState('');

    const [btnSaveText, setbtnSaveText] = useState('Save');
    const [btnSaveTooltip, setbtnSaveTooltip] = useState('Save Plan');

    let [FinancierYear, setFinancierYear] = useState(1);
    let [LOGIN_USER, setLOGIN_USER] = useState('');

    const [CompanyID, setCompanyID] = useState('');

    const [openAlert, setOpenAlert] = useState(false);

    const [loading, setLoading] = React.useState(false);

    const [rows, setTableData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchText, setSearchText] = useState('');

    const [rowsConfirmedOrders, setrowsConfirmedOrders] = useState([]);
    const [filteredData_ConfirmedOrders, setFilteredData_ConfirmedOrders] = useState([]);
    const [searchText_ConfirmedOrders, setSearchText_ConfirmedOrders] = useState('');
    const [selectCOOrders, setselectCOOrders] = useState([]);

    const [reason, setReason] = useState('');
    const [cancelDate, setSelectedDate] = React.useState();

    const [ReasonError, setReasonError] = useState("");
    const [DateError, setDateError] = useState("");

    const [sAmendmentReason, setSAmendmentReason] = useState('');
    const [visibleAmendmentReason, setVisibleAmendmentReason] = useState(false);
    const [amendReasonError, setamendReasonError] = useState("");

    const [selectedCOIds, setSelectedCOIds] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [despatchNo, setDespatchNo] = useState('');
    const [sLength, setSLength] = useState('');
    const [dispatchPlanNo, setDispatchPlanNo] = useState('');

    const [iIndentID, setiIndentID] = useState(0);
    const [iConfirmationID, setiConfirmationID] = useState(0);
    const [iProductID, setiProductID] = useState(0);
    const [iDespatchOrderID, setiDespatchOrderID] = useState(0);
    const [DocumentSeries, SeDocumentSeries] = useState(25);
    const [showReport, setShowReport] = useState(false);
    const [reportRequestBody, setReportRequestBody] = useState(null);


    // despacth filter 
    const billToPartyList = [
        { party_id: 1, party_name: "ABC Industries" },
        { party_id: 2, party_name: "Global Papers" },
        { party_id: 3, party_name: "Star Packaging" },
    ];

    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [searchCO, setSearchCO] = useState('');
    const [billToParty, setBillToParty] = useState('');
    const [prodStatus, setProdStatus] = useState('');

    const { coList, setCoList, getCOAvailableListByDataRange, } = useCOAvailableGForDespatchPlan(setErrorMessage);

    const handleDateFilterChange = (key, date) => {
        // if (key === "from") setFromDate(date);
        // if (key === "to") setToDate(date);
        // if (key === "billto") setBillToParty(date);
        // if (key === "co") setSearchCO(date);
        // if (key === "status") setProdStatus(date);


        // // run only when both dates are chosen
        // if (key === "from" && date && ToDate) getCOAvailableListByDataRange(date, ToDate, billToParty, searchCO, prodStatus, FinancierYear);
        // if (key === "to" && date && FromDate) getCOAvailableListByDataRange(FromDate, date, billToParty, searchCO, prodStatus, FinancierYear);
        // if (key === "billto" && date && FromDate && ToDate) getCOAvailableListByDataRange(FromDate, ToDate, date, searchCO, prodStatus, FinancierYear);
        // if (key === "co" && date && FromDate && ToDate) getCOAvailableListByDataRange(FromDate, ToDate, billToParty, date, prodStatus, FinancierYear);
        // if (key === "status" && date && FromDate && ToDate) getCOAvailableListByDataRange(FromDate, ToDate, billToParty, searchCO, date, FinancierYear);
    };

    const handleSearch = async () => {
        await getCOAvailableListByDataRange(FromDate, ToDate, values.bill_to_party, values.cono, values.prod_status, FinancierYear);
    }

    useEffect(() => {
        const retrievedUserID = localStorage.getItem('userID');
        if (retrievedUserID) {
            setCompanyID(localStorage.getItem('companyid'));
        }
    }, []); // Empty dependency array to run only once on mount


    var sSelectedConfirmationIDList;
    var sSelectedItemIDList;

    const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
        '& .MuiDataGrid-colCell': {
            borderRight: `1px solid ${theme.palette.divider}`, // Add right border to column headers
        },
        '& .MuiDataGrid-columnSeparator': {
            display: 'none', // Hide default column separators
        },
        '& .MuiDataGrid-cell': {
            borderBottom: `1px solid ${theme.palette.divider}`, // Add bottom border to cells
        },
    }));

    const filterData = (data) => {
        const filtered = data.filter(row =>
            Object.values(row).some(value =>
                value && value.toString().toLowerCase().includes(searchText.toLowerCase())
            )
        );
        setFilteredData(filtered);
    };

    const LoadDespatchPlanList = () => {
        if (FromDate == null) {
            showError('Please select the from date', 'warning');
        } else if (ToDate == null) {
            showError('Please select the to date', 'warning');
        } else {
            // const formattedFromDate = dayjs(FromDate).format('YYYY-MMM-DD');
            // const formattedToDate = dayjs(ToDate).format('YYYY-MMM-DD');

            const formattedFromDate = dayjs(FromDate).format('DD/MMM/YYYY'); // or 'YYYY-MM-DD'
            const formattedToDate = dayjs(ToDate).format('DD/MMM/YYYY');     // or 'YYYY-MM-DD'

            const requestBody = {
                SearchFromDate: formattedFromDate,
                SearchToDate: formattedToDate,
                ConstructedGlobalValues: {
                    COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                    COMPANY_ID: localStorage.getItem('companyid'),
                },
            };

            fetch(API_ENDPOINTS.loadDespatchPlanList, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Unable to load despach plan details');
                    }
                    return response.json();
                })
                .then(data => {
                    const formattedData = data.map((row, index) => {
                        const dateOnly = new Date(row.DespatchOrderDate).toLocaleDateString();
                        return { ...row, id: index + 1, dateOnly };
                    });

                    setTableData(formattedData);
                })
                .catch(error => {
                    showError('Unable to load despach plan details', 'error');
                });
        }
    };

    const filterData_ConfirmedOrders = (data) => {
        const filtered = data.filter(row =>
            Object.values(row).some(value =>
                value && value.toString().toLowerCase().includes(searchText_ConfirmedOrders.toLowerCase())
            )
        );
        setFilteredData_ConfirmedOrders(filtered);
    };

    const LoadConfirmedOrderList = () => {
        if (FromCODate == null) {
            showError('Please select the from date', 'warning');
        } else if (ToCODate == null) {
            showError('Please select the to date', 'warning');
        } else {
            const formattedFromCODate = dayjs(FromCODate).format('DD/MMM/YYYY'); // or 'YYYY-MM-DD'
            const formattedToCODate = dayjs(ToCODate).format('DD/MMM/YYYY');     // or 'YYYY-MM-DD'

            const requestBody = {
                FromDate: formattedFromCODate,
                ToDate: formattedToCODate,
                BillToCustomerID: values.bill_to_party?.party_id || null,
                ConfirmationNo: values.cono || null,
                MAProdStatus: null,
                ConstructedGlobalValues: {
                    COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                    COMPANY_ID: localStorage.getItem('companyid'),
                    LOGIN_USER: localStorage.getItem('userID')
                },
            };
            fetch(API_ENDPOINTS.loadConfirmedOrderList, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Unable to load confirmation order details');
                    }
                    return response.json();
                })
                .then(data => {

                    if (data && data.length > 0) {
                        const formattedData = data.map((row, index) => {
                            const dateOnly = new Date(row.ConfirmationDate).toLocaleDateString();
                            return { ...row, id: index + 1, dateOnly };
                        });

                        setrowsConfirmedOrders(formattedData);
                        filterData_ConfirmedOrders(formattedData);
                    }
                    else {
                        setrowsConfirmedOrders([]);
                        filterData_ConfirmedOrders([]);
                    }

                })
                .catch(error => {

                    showError('Unable to load confirmation order details', 'error');
                });
        }
    };


    const showSnackbar = () => {
        setSnackbarOpen(true);
    };

    const handleFromCODate = (date) => {
        setFromCODate(dayjs(date));
    };

    const handleToCODate = (date) => {
        setToCODate(dayjs(date));
    };

    // Automatically load confirmed orders whenever both dates are selected
    useEffect(() => {
        if (FromCODate && ToCODate) {
            LoadConfirmedOrderList();
        }
    }, [FromCODate, ToCODate]);


    const handlerOrderDate = (date) => {
        setOrderDate(dayjs(date));
    };
    const handleScheduleDate = (date) => {
        setScheduleDate(dayjs(date));
    };

    const handleCreateDispatchPlans = () => {
        setViewCreateDispatchPlan(true);
        setisViewDispatchPlan(false);
        setviewCreateDispatchPlanEntry(false);
        setisVisible_commanButtons(false);
        setviewDispatchItem(false);
        SetfromModule('Despatch Plan List')

        setisVisiblebtnCreateDespatchPlan(true);
        setisVisiblebtnAddSelectedCO(false);
    };



    const LoadDespatchOrderDetail = (requestBody, status) => {

        setLoading(true);
        fetch(API_ENDPOINTS.loadDespatchOrderDetail, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestBody)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Unable to load despatch plan details');
                }
                return response.json();
            })
            .then(data => {

                SetheaderDespatchplan(data.SOrderStatus + " despatch plan");
                setDespatchNo('Auto');
                setOrderDate(data.SDespatchOrderDate);

                if (data.SScheduledDate !== null) {
                    setScheduleDate(data.SScheduledDate);
                }
                SetRemarks(data.SRemarks);

                const fdata = data.SSalesOrderItems.map((row, index) => {
                    return { ...row, id: index + 1 };
                });
                setrowsConfirmedOrdersDespacth(fdata);

                const fdata1 = data.DespatchPlanReelOrdersList.map((row, index) => {
                    return { ...row, id: index + 1 };
                });
                setrowsReelItems(fdata1);

                const fdata2 = data.DespatchPlanSheetOrdersList.map((row, index) => {
                    return { ...row, id: index + 1 };
                });
                setrowsSheetItems(fdata2);

                const fdata3 = data.DespatchPlanQtySummary.map((row, index) => {
                    return { ...row, id: index + 1 };
                });
                setplannedQtyData(fdata3);


                updateTotalQty(fdata, fdata3, fdata1, fdata2);

                RefreshStatus(status);
                setLoading(false);
            })
            .catch(error => {
                setAlertMessage('Unable to load despatch plan details');
                setalertsevierity('error');
                showSnackbar();
                setLoading(false);
            });
    }

    const updateTotalQty = (fdata, fdata3, GlobalReelRows, GlobalSheetRows) => {
        setLoading(true);

        const updatedFdata = fdata.map(oRowItem => {
            let SIPlanned_Qty = 0;
            let ReelBundleCount = 0;
            let ReelCount = 0;
            let BundleCount = 0;

            GlobalSheetRows.forEach(oRowSheet => {
                if (oRowSheet.SelectItem && oRowItem.SOrderConfirmationId === oRowSheet.ConfirmationOrderID && oRowItem.SProductID === oRowSheet.ProductID) {
                    SIPlanned_Qty += oRowSheet.QtyPlanned;
                    ReelBundleCount += 1;
                    BundleCount += 1; // Add BundleCount increment for sheet orders
                }
            });

            GlobalReelRows.forEach(oRowReel => {
                if (oRowReel.SelectItem && oRowItem.SOrderConfirmationId === oRowReel.ConfirmationOrderID && oRowItem.SProductID === oRowReel.ProductID) {
                    SIPlanned_Qty += oRowReel.QtyPlanned;
                    ReelBundleCount += 1;
                    ReelCount += 1; // Add ReelCount increment for reel orders
                }
            });

            SIPlanned_Qty = Math.round(SIPlanned_Qty * 10000) / 10000;

            return {
                ...oRowItem,
                SIPlanned_Qty,
                ReelBundleCount,
                ReelCount,
                BundleCount
            };
        });

        setrowsConfirmedOrdersDespacth(updatedFdata);

        const updatedFdata3 = fdata3.map(oRowQty => {
            let TotalQty = 0;
            updatedFdata.forEach(oRowItem => {
                if (
                    oRowQty.ShipToArea === oRowItem.ShipToArea &&
                    oRowQty.ShipToCity === oRowItem.ShipToCity &&
                    oRowQty.ShipToState === oRowItem.ShipToState
                ) {
                    TotalQty += oRowItem.SIPlanned_Qty;
                }
            });
            return {
                ...oRowQty,
                TotalQty,
            };
        });

        setplannedQtyData(updatedFdata3);
        setLoading(false);
    };



    // const updateTotalQty = (fdata, fdata3, GlobalReelRows, GlobalSheetRows) => {
    //     setLoading(true);
    //     // Loop through each row in rowsConfirmedOrdersDespacth
    //     fdata.forEach(oRowItem => {
    //         // Initialize SIPlanned_Qty and ReelBundleCount to 0 for each row
    //         oRowItem.SIPlanned_Qty = 0;
    //         oRowItem.ReelBundleCount = 0;

    //         // Loop through each row in rowsSheetItems
    //         GlobalSheetRows.forEach(oRowSheet => {
    //             if (oRowSheet.SelectItem && oRowItem.SOrderConfirmationId === oRowSheet.ConfirmationOrderID && oRowItem.SProductID === oRowSheet.ProductID) {
    //                 oRowItem.SIPlanned_Qty += oRowSheet.QtyPlanned;
    //                 oRowItem.ReelBundleCount += 1;
    //             }
    //         });

    //         // Loop through each row in rowsReelItems
    //         GlobalReelRows.forEach(oRowReel => {
    //             if (oRowReel.SelectItem && oRowItem.SOrderConfirmationId === oRowReel.ConfirmationOrderID && oRowItem.SProductID === oRowReel.ProductID) {
    //                 oRowItem.SIPlanned_Qty += oRowReel.QtyPlanned;
    //                 oRowItem.ReelBundleCount += 1;
    //             }
    //         });

    //         // Round SIPlanned_Qty to 4 decimal places
    //         oRowItem.SIPlanned_Qty = Math.round(oRowItem.SIPlanned_Qty * 10000) / 10000;
    //     });

    //     // Assuming you want to update the state with the modified rowsConfirmedOrdersDespacth
    //     setrowsConfirmedOrdersDespacth([...fdata]);
    //     setLoading(false);

    //     // Loop through each row in plannedQtyData
    //     fdata3.forEach(oRowQty => {
    //         // Initialize TotalQty to 0 for each row
    //         oRowQty.TotalQty = 0;

    //         // Loop through each row in rowsConfirmedOrdersDespacth
    //         fdata.forEach(oRowItem => {
    //             // Check if the ShipToCity and ShipToState match between the rows
    //             if (oRowQty.ShipToCity === oRowItem.ShipToCity && oRowQty.ShipToState === oRowItem.ShipToState) {
    //                 // If there's a match, update TotalQty by adding SIPlanned_Qty from the current row in rowsConfirmedOrdersDespacth
    //                 oRowQty.TotalQty += oRowItem.SIPlanned_Qty;
    //             }
    //         });
    //     });

    //     // Assuming you want to update the state with the modified plannedQtyData
    //     setplannedQtyData([...fdata3]);
    // }



    const LoadConfirmationOrderDetailForDespatchOrder = async (requestBody) => {

        setLoading(true);
        await fetch(API_ENDPOINTS.loadConfirmationOrderDetailForDespatchOrder, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestBody)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Unable to load confirmation order details');
                }
                return response.json();
            })
            .then(data => {
                setDespatchNo('Auto');
                setOrderDate(dayjs());

                if (data.SScheduledDate !== null) {
                    setScheduleDate(data.SScheduledDate);
                }
                else {
                    setScheduleDate(dayjs());
                }

                SetRemarks(data.SRemarks);

                const fdata = data.SSalesOrderItems.map((row, index) => {
                    return { ...row, id: index + 1 };
                });
                setrowsConfirmedOrdersDespacth(fdata);

                const fdata1 = data.DespatchPlanReelOrdersList.map((row, index) => {
                    return { ...row, id: index + 1 };
                });

                let GlobalReelRows;
                let GlobalSheetRows;

                if (rowsReelItems.length > 0) {
                    const updatedReelRows = fdata1.map(row => {
                        // Find the corresponding row in rowsSheetItemsFiltered
                        const filteredRow = rowsReelItems.find(filteredRow => filteredRow.id === row.id);

                        // If the filtered row exists and matches the condition, update the SelectItem property
                        if (filteredRow && filteredRow.id === row.id) {
                            // Replace 'filteredRow.SelectItem' with the value you want to assign to SelectItem
                            return { ...row, SelectItem: filteredRow.SelectItem };
                        } else {
                            // If the filtered row doesn't exist or doesn't match, keep the row as it is
                            return row;
                        }
                    });
                    setrowsReelItems(updatedReelRows);
                    GlobalReelRows = updatedReelRows;
                }
                else {
                    setrowsReelItems(fdata1);
                    GlobalReelRows = fdata1;
                }


                const fdata2 = data.DespatchPlanSheetOrdersList.map((row, index) => {
                    return { ...row, id: index + 1 };
                });


                if (rowsSheetItems.length > 0) {
                    const updatedSheetRows = fdata2.map(row => {
                        // Find the corresponding row in rowsSheetItemsFiltered
                        const filteredRow = rowsSheetItems.find(filteredRow => filteredRow.id === row.id);
                        // If the filtered row exists and matches the condition, update the SelectItem property
                        if (filteredRow && filteredRow.id === row.id) {
                            // Replace 'filteredRow.SelectItem' with the value you want to assign to SelectItem
                            return { ...row, SelectItem: filteredRow.SelectItem };
                        } else {
                            // If the filtered row doesn't exist or doesn't match, keep the row as it is
                            return row;
                        }
                    });
                    setrowsSheetItems(updatedSheetRows);
                    GlobalSheetRows = updatedSheetRows;
                }
                else {
                    setrowsSheetItems(fdata2);
                    GlobalSheetRows = fdata2;
                }

                const fdata3 = data.DespatchPlanQtySummary.map((row, index) => {
                    return { ...row, id: index + 1 };
                });
                setplannedQtyData(fdata3);

                RefreshStatus('Create');
                setbtnSaveText('Save');
                SetfromModule('Confirmed Orders');
                updateTotalQty(fdata, fdata3, GlobalReelRows, GlobalSheetRows);
                setLoading(false);

            })
            .catch(error => {
                showError('Unable to load confirmation details', 'error');
                setLoading(false);
            });
    }

    const handleShowDispatchPlansEntry = () => {
        const selectedCOIds = selectCOOrders.map(row => row.SOrderConfirmationId);
        const selectedItems = selectCOOrders.map(row => row.SOrderItemId);

        setSelectedCOIds(selectedCOIds);
        setSelectedItems(selectedItems);

        if (selectedItems.length === 0) {
            showError('Please select the order items to include in the despatch plan', 'warning');
            return;
        }
        const sListCOIds = selectedCOIds.join(",");
        const sListItemID = selectedItems.join(",");

        setiIndentID(selectCOOrders[0].SOrderId);
        setiConfirmationID(selectCOOrders[0].SOrderConfirmationId);

        sSelectedConfirmationIDList = sListCOIds;
        sSelectedItemIDList = sListItemID;

        if (selectCOOrders[0].SOrderId > 0 && selectCOOrders[0].SOrderConfirmationId > 0) {
            const requestBody = {
                SOrderId: selectCOOrders[0].SOrderId,
                SOrderConfirmationId: selectCOOrders[0].SOrderConfirmationId,
                SSelectedConfirmationIdList: sListCOIds,
                SSelectedItemIdList: sListItemID,
                ConstructedGlobalValues: {
                    COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                    COMPANY_ID: localStorage.getItem('companyid'),
                },
            };
            LoadConfirmationOrderDetailForDespatchOrder(requestBody);
        }
    };



    const handleViewReportOrg = () => {
        if (iDespatchOrderID > 0) {
            const requestBody = {
                SOrderDespatchOrderId: iDespatchOrderID,
                SOrderId: 0,
                SOrderConfirmationId: 0,
                ConstructedGlobalValues: {
                    COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                    COMPANY_ID: localStorage.getItem('companyid'),
                },
            };
            ShowDespatchPlan(requestBody);
        }
    };
    const handleViewReport = async () => {
        if (iDespatchOrderID > 0) {
            await fetchDispatchReportData();
            setShowReport(true); // open the dialog
            setViewDispatch(false);
        }
    };

    const handleCloseReport = () => {
        setShowReport(false);
        setReportRequestBody(null);
        setViewDispatch(true);
    };

    // fetch dispatch report data
    const fetchDispatchReportData = async () => {

        const payload = {
            SOrderDespatchOrderId: iDespatchOrderID,
            SOrderId: 0,
            SOrderConfirmationId: 0,
            ConstructedGlobalValues: {
                COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                COMPANY_ID: localStorage.getItem('companyid'),
            },
        };
        await fetch(API_ENDPOINTS.generateDespatchPlanForViewReport, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Unable to load confirmation order details');
                }
                return response.json();
            })
            .then(data => {

                setReportRequestBody(data);
            })
            .catch(error => {
                showError('Unable to load confirmation details', 'error');

            });
    }

    // previous report data a
    const ShowDespatchPlan = async (requestBody) => {
        try {

            const response = await axios.post(API_ENDPOINTS.generateDespatchPlan,
                requestBody,
                {
                    responseType: 'arraybuffer' // Important to receive binary data
                }
            );

            // Extract INVO5 object from response headers             

            // Handle the binary data response as before
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'report.pdf');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            showError('Despatch Plan exported successfully..!', 'success')

        } catch (error) {
            console.error('Error generating report:', error);
            // Handle error
        } finally {
            setLoading(false);
        }
    };


    const handleBackTofromDespacthPlanEntry = () => {
        setViewCreateDispatchPlan(false);
        setisViewDispatchPlan(false);
        setviewCreateDispatchPlanEntry(false);
        setisVisible_commanButtons(false);
        setviewDispatchItem(false);

        if (fromModule === 'Despatch Plan List') {
            // setisVisible_DespatchPlan(true);
            handleCallBack();
        }
        //&& fromSubModule === ''
        else if (fromModule === 'Confirmed Orders') {
            setViewCreateDispatchPlan(true);
        }
        else if (fromSubModule === 'Despatch Plan Entry') {
            setviewCreateDispatchPlanEntry(true);
            setisVisible_commanButtons(true);
            SetfromSubModule('');
        }
    }

    const handleCancel = (e) => {
        setisVisible_cancelDetail(true);
        handleCancelPlanData(e);
    }

    const handleOn_OrderItemsCellClick = (params, event) => {

        const iConfirmationID = params.SOrderConfirmationId;
        const iProductID = params.SProductID;

        setiConfirmationID(iConfirmationID);
        setiProductID(iProductID);

        var updatedDespatchPlanReelStockAvailable1;
        if (params.SILength === 0) {
            updatedDespatchPlanReelStockAvailable1 = rowsReelItems.filter(pItemNew => {
                return (
                    (pItemNew.ConfirmationOrderID === iConfirmationID && pItemNew.ProductID === iProductID) ||
                    (pItemNew.OrderRefNo === "SWO" && pItemNew.ProductID === iProductID && (pItemNew.ConfirmationOrderID === iConfirmationID || pItemNew.ConfirmationOrderID === 0))
                );
            });
            setrowsReelItemsFiltered(updatedDespatchPlanReelStockAvailable1);
        }

        else {
            updatedDespatchPlanReelStockAvailable1 = rowsSheetItems.filter(pItemNew => {
                return (
                    (pItemNew.ConfirmationOrderID === iConfirmationID && pItemNew.ProductID === iProductID) ||
                    (pItemNew.OrderRefNo === "SWO" && pItemNew.ProductID === iProductID && (pItemNew.ConfirmationOrderID === iConfirmationID || pItemNew.ConfirmationOrderID === 0))
                );
            });
            setrowsSheetItemsFiltered(updatedDespatchPlanReelStockAvailable1);
        }

        if (params.SILength === 0) {
            setisVisibleReelItem(true);
            setisVisibleSheetItem(false);
        }
        else {
            setisVisibleSheetItem(true);
            setisVisibleReelItem(false);
        }

        setSLength(params.SILength);
        setViewCreateDispatchPlan(false);
        setisViewDispatchPlan(false);
        setviewDispatchItem(true);
        setisVisible_commanButtons(true);
        SetfromSubModule('Despatch Plan Entry');
        handleOpen();

    };



    useEffect(() => {
        if (selectedRow.length !== 0) {
            handleOnCellClick(selectedRow);
        }
        else {

            setviewCreateDispatchPlanEntry(false);
            setisVisible_commanButtons(false);
            setviewDispatchItem(false);
            SetfromModule('Despatch Plan List')

            setisVisiblebtnCreateDespatchPlan(true);
            setisVisiblebtnAddSelectedCO(false);
        }
    }, [selectedRow])

    const handleOnCellClick = (params, event) => {
        const status = params.DespatchOrderStatus;
        setiIndentID(params.IndentId);
        setiConfirmationID(params.ConfirmationOrderId);
        setiDespatchOrderID(params.DespatchOrderId);
        setDispatchPlanNo(params.DespatchOrderNo);

        const requestBody = {
            SOrderId: params.IndentId,
            SOrderConfirmationId: params.ConfirmationOrderId,
            SOrderDespatchOrderId: params.DespatchOrderId,
            ConstructedGlobalValues: {
                COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                COMPANY_ID: localStorage.getItem('companyid'),
            },
        };
        LoadDespatchOrderDetail(requestBody, status);
        SetfromModule('Despatch Plan List');
        setbtnSaveText('Update');
        setbtnSaveTooltip('Update Plan');
    };

    const RefreshStatus = (status) => {
        setbtnApprove(false);
        setbtnSaveUpdateOrdershow(false);
        setbtnAmendmentshow(false);
        setbtnPrint(false);
        setbtnCancel(false);
        setVisibleAmendmentReason(false);

        setbtnAmendmentshow(false);
        if (status === 'New' || status === '[New]') {
            SetheaderDespatchplan('New Despatch Plan')
            setbtnSaveUpdateOrdershow(true);
            setbtnCancel(true);
            setbtnApprove(true);
        }
        else if (status === 'Processed') {
            SetheaderDespatchplan('Despatch Plan in Process')
            setbtnPrint(true);
        }
        else if (status === 'UnderAmendment') {
            SetheaderDespatchplan('Amended Despatch Plan')
            setbtnSaveUpdateOrdershow(true);
            setbtnCancel(true);
            setbtnApprove(true);
        }
        else if (status === 'Cancelled') {
            SetheaderDespatchplan('Despatch Plan Cancelled')
        }
        else if (status === 'Approved') {
            SetheaderDespatchplan('Approved Despatch Plan ')
            setbtnCancel(true);
            setbtnPrint(true);
            setbtnAmendmentshow(true);
            setVisibleAmendmentReason(true);
        }
        else if (status === 'Create') {
            SetheaderDespatchplan('New Despatch Plan')
            setbtnSaveUpdateOrdershow(true);
        }
        setViewCreateDispatchPlan(false);
        setisViewDispatchPlan(false);
        setviewCreateDispatchPlanEntry(true);
        setisVisible_commanButtons(true);
        setviewDispatchItem(false);
    }

    const handleEnterReason = (e) => {
        setReason(e.target.value);
    }
    const handleDateChange = (date) => {
        const selectedDate = new Date(date); // Assuming 'date' is a valid date string
        const formattedDate = selectedDate.toLocaleDateString('en-US');
        setSelectedDate(formattedDate);
    };

    const handleSelectAmendmentReason = (e) => {
        setSAmendmentReason(e.target.value);
    }

    const [rowsConfirmedOrdersDespacth, setrowsConfirmedOrdersDespacth] = useState([]);
    const [rowsReelItems, setrowsReelItems] = useState([]);
    const [rowsSheetItems, setrowsSheetItems] = useState([]);
    const [rowsReelItemsFiltered, setrowsReelItemsFiltered] = useState([]);
    const [rowsSheetItemsFiltered, setrowsSheetItemsFiltered] = useState([]);
    const [plannedQtyData, setplannedQtyData] = useState([]);

    const areAllRowsSelected = () => {
        if (sLength > 0) {
            return rowsSheetItemsFiltered.every(row => row.SelectItem);
        } else {
            return rowsReelItemsFiltered.every(row => row.SelectItem);
        }
    };

    const columnsSheetItems = [
        {
            field: 'SelectItem',
            headerName: '',
            width: 80,
            sortable: false,
            filterable: false,
            renderHeader: () => (
                <Checkbox
                    onChange={handleSelectAllCheckboxChange} checked={areAllRowsSelected()}
                />
            ),
            renderCell: (params) => (
                <Checkbox
                    checked={params.row.SelectItem}
                    onChange={(event) => handleCheckboxChange(event, params.row.id)}
                />
            )
        },
        { field: 'OrderRefNo', headerName: 'Stock Ref.', width: 100 },
        { field: 'Variety', headerName: 'Variety', width: 110 },
        { field: 'GSM', headerName: 'GSM', width: 30 },
        { field: 'Width', headerName: 'Width', width: 30 },
        { field: 'Length', headerName: 'Length', width: 30 },
        { field: 'Location', headerName: 'Location', width: 130 },
        { field: 'LotNo', headerName: 'Lot No', width: 70 },
        { field: 'BundleNumber', headerName: 'Bundle Number', width: 150 },
        { field: 'NoOfSheets', headerName: 'Sheets/Ream', width: 80 },
        { field: 'WeightPerBundle', headerName: 'Bundle Weight(kg)', width: 120 },
        { field: 'NoofReams', headerName: 'Number of Ream', width: 120 },
        { field: 'AvailableBundles', headerName: 'Actual Bundle Loaded', width: 120 },

    ];

    const columnsReelItems = [
        {
            field: 'SelectItem',
            headerName: '',
            width: 80,
            sortable: false,
            filterable: false,
            renderHeader: () => (
                <Checkbox
                    onChange={handleSelectAllCheckboxChange}
                    checked={areAllRowsSelected()}
                />
            ),
            renderCell: (params) => (
                <Checkbox
                    checked={params.row.SelectItem}
                    onChange={(event) => handleCheckboxChange(event, params.row.id)}
                />
            )
        },
        { field: 'OrderRefNo', headerName: 'Stock Ref.', width: 100 },
        { field: 'Variety', headerName: 'Variety', width: 110 },
        { field: 'GSM', headerName: 'GSM', width: 30 },
        { field: 'Width', headerName: 'Width', width: 30 },
        { field: 'Length', headerName: 'Length', width: 30 },
        { field: 'Location', headerName: 'Location', width: 130 },
        { field: 'LotNo', headerName: 'Lot No', width: 70 },
        { field: 'ReelNumber', headerName: 'Reel Number', width: 150 },
        { field: 'ReelWeight', headerName: 'Reel Weight(kg)', width: 120 },

    ];

    const SizeCell = ({ row }) => {
        const size = `${row.Width} x ${row.Length}`;

        return (
            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center' }}>
                {size}
            </div>
        );
    };
    // Function to calculate percentage
    const calculatePercentage = (plannedQty, confirmedQty) => {
        return (plannedQty / confirmedQty) * 100;
    };

    // Custom cell renderer for Filled Qty column
    const FilledQtyCell = ({ row }) => {
        const percentage = calculatePercentage(row.PlannedQty, row.ConfirmedQty);
        let percentageColor;

        if (percentage > 100) {
            percentageColor = 100;
        }
        else {
            percentageColor = percentage;
        }
        return (
            <div style={{ width: '100%', height: '100%', position: 'relative', marginBottom: '0px' }}>
                <LinearProgress
                    variant="determinate"
                    value={percentageColor}
                    style={{ width: '100%', height: '100%', position: 'absolute', }}
                    color={
                        percentageColor < 25 ? 'error' : // Red color for less than 25%
                            percentageColor <= 70 ? 'warning' : // Yellow color for 25% to 70%
                                'success' // Green color for above 70%
                    }
                />
                <Typography
                    variant="body2"
                    color="textSecondary"
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                    }}
                >
                    {percentage.toFixed(2)} %
                </Typography>
            </div>
        );
    };

    const getStatusProperties = (status) => {
        let label, color, icon, borderColor;

        switch (status) {
            case 'New':
                label = 'New';
                color = '#33691e';
                icon = <ScheduleIcon />;
                borderColor = '#1976d2';
                break;
            case 'Processed':
                label = 'Processed';
                color = '#689f38';
                icon = <PublishedWithChangesIcon />;
                borderColor = '#388e3c';
                break;
            case 'UnderAmendment':
                label = 'Under Amendment';
                color = '#455a64';
                icon = <Amendicon />;
                borderColor = '#f57c00';
                break;
            case 'Cancelled':
                label = 'Cancelled';
                color = '#ff7043';
                icon = <CancelIcon1 />;
                borderColor = '#d32f2f';
                break;
            case 'Approved':
                label = 'Approved';
                color = '#009688';
                icon = <CheckCircleOutlineIcon />;
                borderColor = '#689f38';
                break;
            default:
                label = 'Unknown';
                color = '#9e9e9e'; // Grey color
                icon = null;
                borderColor = '#757575';
        }

        return { label, color, icon, borderColor };
    };



    // const [selectedOrders, setSelectedOrders] = useState([]);

    // const isSelected = (orderId) => selectedOrders.indexOf(orderId) !== -1;

    // const [gridAutoRows, setGridAutoRows] = useState(calculateGridAutoRows());

    // useEffect(() => {
    //     const handleResize = () => {
    //         setGridAutoRows(calculateGridAutoRows());
    //     };

    //     window.addEventListener('resize', handleResize);
    //     return () => {
    //         window.removeEventListener('resize', handleResize);
    //     };
    // }, []);


    useEffect(() => {
        LoadDespatchPlanList();
        LoadConfirmedOrderList();
    }, []);

    function calculateGridAutoRows() {
        const screenHeight = window.innerHeight;
        const rows = Math.floor((screenHeight - 70) / 3); // Adjust 50 as needed for margins or paddings
        return `${rows}px`;
    }

    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);

        const updatedReelRows = rowsReelItems.map(row => {
            // Find the corresponding row in rowsSheetItemsFiltered
            const filteredRow = rowsReelItemsFiltered.find(filteredRow => filteredRow.id === row.id);

            // If the filtered row exists and matches the condition, update the SelectItem property
            if (filteredRow && filteredRow.id === row.id) {
                // Replace 'filteredRow.SelectItem' with the value you want to assign to SelectItem
                return { ...row, SelectItem: filteredRow.SelectItem };
            } else {
                // If the filtered row doesn't exist or doesn't match, keep the row as it is
                return row;
            }
        });
        setrowsReelItems(updatedReelRows);

        const updatedsheetRows = rowsSheetItems.map(row => {
            // Find the corresponding row in rowsSheetItemsFiltered
            const filteredRow = rowsSheetItemsFiltered.find(filteredRow => filteredRow.id === row.id);

            // If the filtered row exists and matches the condition, update the SelectItem property
            if (filteredRow && filteredRow.id === row.id) {
                // Replace 'filteredRow.SelectItem' with the value you want to assign to SelectItem
                return { ...row, SelectItem: filteredRow.SelectItem };
            } else {
                // If the filtered row doesn't exist or doesn't match, keep the row as it is
                return row;
            }
        });

        setrowsSheetItems(updatedsheetRows);
        updateReelStock();
        updateSheetStock();
        updateTotalQty(rowsConfirmedOrdersDespacth, plannedQtyData, rowsReelItemsFiltered, rowsSheetItemsFiltered);

    };

    const updateReelStock = () => {
        rowsReelItemsFiltered.forEach(oRow => {
            if (oRow.SelectItem) {
                if (headerDespatchplan.toLowerCase() === "New Despatch Plan" || headerDespatchplan.toLowerCase() === "Amended Despatch Plan") {
                    if (parseFloat(oRow.NoOfReelsPlanned) >= 0 && parseFloat(oRow.AvailableReels) >= 0 && parseFloat(oRow.NoOfReelsPlanned) > parseFloat(oRow.AvailableReels)) {
                        showError("Reels Planned cannot be more than " + oRow.AvailableReels.toString(), "error");
                        oRow.NoOfReelsPlanned = parseFloat(oRow.AvailableReels);
                    } else if (parseFloat(oRow.NoOfReelsPlanned) === 0) {
                        oRow.NoOfReelsPlanned = parseFloat(oRow.AvailableReels);
                    }
                    if (oRow.OrderRefNo === "SWO" && oRow.ProductID === iProductID) {
                        oRow.OrderID = iProductID;
                        oRow.ConfirmationOrderID = iConfirmationID;
                    }
                }
            } else if (oRow.OrderRefNo === "SWO" && oRow.ProductID === iProductID) {
                oRow.OrderID = 0;
                oRow.ConfirmationOrderID = 0;
            }
            let oLineQtyPlanned = 0;
            let oLineReelsPlanned = 0;
            let oLinePerReelWeight = 0;
            if (parseFloat(oRow.NoOfReelsPlanned) >= 0 && parseFloat(oRow.ReelWeight) >= 0) {
                oLineReelsPlanned = parseInt(oRow.NoOfReelsPlanned);
                oLinePerReelWeight = parseFloat(oRow.ReelWeight);
                oLineQtyPlanned = oLineReelsPlanned * oLinePerReelWeight; // / 1000
                oRow.QtyPlanned = Math.round(oLineQtyPlanned * 10000) / 10000;
            }
        });
        // Assuming you want to update the state with the modified rowsReelItemsFiltered
        setrowsReelItemsFiltered([...rowsReelItemsFiltered]);
    }


    const updateSheetStock = () => {
        rowsSheetItemsFiltered.forEach(oRow => {
            if (oRow.SelectItem) {
                if (headerDespatchplan.toLowerCase() === "New Despatch Plan" || headerDespatchplan.toLowerCase() === "Amended Despatch Plan") {

                    if (parseFloat(oRow.NoOfBundlesPlanned) >= 0 && parseFloat(oRow.AvailableBundles) >= 0 && parseFloat(oRow.NoOfBundlesPlanned) > parseFloat(oRow.AvailableBundles)) {
                        showError("Bundles Planned cannot be more than " + oRow.AvailableBundles.toString(), "error");
                        oRow.NoOfBundlesPlanned = parseFloat(oRow.AvailableBundles);
                    } else if (parseFloat(oRow.NoOfBundlesPlanned) === 0) {
                        oRow.NoOfBundlesPlanned = parseFloat(oRow.AvailableBundles);
                    }
                    if (oRow.OrderRefNo === "SWO" && oRow.ProductID === iProductID) {
                        oRow.OrderID = iProductID;
                        oRow.ConfirmationOrderID = iConfirmationID;
                    }
                }
            } else if (oRow.OrderRefNo === "SWO" && oRow.ProductID === iProductID) {
                oRow.OrderID = 0;
                oRow.ConfirmationOrderID = 0;
            }

            let oLineQtyPlanned = 0;
            let oLineBundlePlanned = 0;
            let oLinePerBundleWeight = 0;
            oLineBundlePlanned = parseInt(oRow.NoOfBundlesPlanned);
            oLinePerBundleWeight = parseFloat(oRow.WeightPerBundle);
            oLineQtyPlanned = oLineBundlePlanned * oLinePerBundleWeight; // / 1000
            oRow.QtyPlanned = Math.round(oLineQtyPlanned * 10000) / 10000;
        });

        // Assuming you want to update the state with the modified rowsSheetItemsFiltered
        setrowsSheetItemsFiltered([...rowsSheetItemsFiltered]);
    }


    const showError = (message, severity) => {
        setAlertMessage(message);
        setalertsevierity(severity);
        showSnackbar();
        return true;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        if (FromDate == null) {
            showError('Please select the from date', 'warning');
        }
        else if (ToDate == null) {
            showError('Please select the to date', 'warning');
        }
        else {
            LoadDespatchPlanList();
        }
    };

    const handleSubmitConfirmationOrder = (event) => {
        event.preventDefault();

        if (FromCODate == null) {
            showError('Please select the from date', 'warning');
        }
        else if (ToCODate == null) {
            showError('Please select the to date', 'warning');
        }
        else {
            LoadConfirmedOrderList();
        }
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const handleKeyPress = (event) => {
        if (event.altKey && event.key.toLowerCase() === 'c') {
            handleCreateDispatchPlans();
        }
        if (event.altKey && event.key.toLowerCase() === 'p') {
            // handleBackTofromConnfrimOrderList();
            handleCallBack();
        }
        if (event.altKey && event.key.toLowerCase() === 'n') {
            handleShowDispatchPlansEntry();
        }
        if (event.altKey && event.key.toLowerCase() === 'b') {
            handleBackTofromDespacthPlanEntry();
        }
    };

    useEffect(() => {
        window.addEventListener('keydown', handleKeyPress);
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [handleCreateDispatchPlans, handleBackTofromConnfrimOrderList, handleShowDispatchPlansEntry, handleBackTofromDespacthPlanEntry]);


    const handleCheckboxChange = (event, rowId) => {
        if (sLength > 0) {
            const updatedRows = rowsSheetItemsFiltered.map(row =>
                row.id === rowId ? { ...row, SelectItem: event.target.checked } : row
            );
            setrowsSheetItemsFiltered(updatedRows);
        }
        else {
            const updatedRows = rowsReelItemsFiltered.map(row =>
                row.id === rowId ? { ...row, SelectItem: event.target.checked } : row
            );
            setrowsReelItemsFiltered(updatedRows);
        }
    };

    const handleSelectAllCheckboxChange = (event) => {
        let updatedRows;

        if (sLength > 0) {
            updatedRows = rowsSheetItemsFiltered.map(row => ({ ...row, SelectItem: event.target.checked }));
            setrowsSheetItemsFiltered(updatedRows);
        } else {
            updatedRows = rowsReelItemsFiltered.map(row => ({ ...row, SelectItem: event.target.checked }));
            setrowsReelItemsFiltered(updatedRows);
        }
    };


    const handleCheckboxChangeForConfirmationOrder = (event, id) => {
        const newSelected = event.target.checked
            ? [...selectCOOrders, id]
            : selectCOOrders.filter(selectedId => selectedId !== id);
        setselectCOOrders(newSelected);


        const updatedRows = filteredData_ConfirmedOrders.map(row =>
            row.id === id ? { ...row, SelectItem: event.target.checked } : row
        );
        setrowsConfirmedOrders(updatedRows);
        filterData_ConfirmedOrders(updatedRows);

        const filteredData = updatedRows.filter(row => row.SelectItem === true);
        setselectCOOrders(filteredData);
    };




    const handleCancelPlanData = (actionType) => {
        // e.preventDefault();

        try {
            let formDirty = false;
            let ApproveAndAmend;

            if (headerDespatchplan.trim() === 'Approved Despatch Plan') {
                ApproveAndAmend = 'approved';
            }

            if (!formDirty) {
                if (cancelDate === '') {
                    showError('Cancel date is a required field', 'error');
                    return;
                }
                else if (reason === '') {
                    showError('Cancel Reason is a required field', 'error');
                    return;
                }
                else {

                    const confirm = window.confirm(`Are you sure want to Cancel this order?, Confirm Cancellation`);

                    if (!confirm) {
                        return;
                    }

                    setOpenAlert(false);
                    setLoading(true);

                    const formattedDate = dayjs(cancelDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ');

                    const clsDespatchOrder = {
                        SOrderId: iIndentID,
                        SOrderConfirmationId: iConfirmationID,
                        SOrderDespatchOrderId: iDespatchOrderID,
                        SOrderStatus: "Cancelled",
                        SCancelledReason: reason,
                        SCancelledDate: formattedDate,
                    };

                    const requestBody = {
                        clsDespatchOrder: clsDespatchOrder,
                        ApproveAndAmend: ApproveAndAmend,
                        ConstructedGlobalValues: {
                            COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                            COMPANY_ID: localStorage.getItem('companyid'),
                            LOGIN_USER: LOGIN_USER
                        },
                    };

                    fetch(API_ENDPOINTS.cancelDespatchPlanDetails, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(requestBody),
                    })
                        .then(response => {
                            if (!response.ok) {
                                throw new Error('Unable to cancel Despatch Plan')
                            }
                            return response.json();
                        })
                        .then(data => {
                            showError(data.returnmsg, 'success');
                            setiIndentID(requestBody.clsDespatchOrder.SOrderId);
                            setiConfirmationID(requestBody.clsDespatchOrder.SOrderConfirmationId);
                            setiDespatchOrderID(requestBody.clsDespatchOrder.SOrderDespatchOrderId);
                            LoadDespatchPlanList();
                            RefreshStatus(data.clsDespatchOrder.SOrderStatus);
                        })
                        .catch(error => {
                            showError('Unable to cancel Despatch Plan.!', 'error');
                        });
                }
            }

            setTimeout(() => {
                setLoading(false);
            }, 3000);
        } catch (error) {
            console.error('Error:', error);

        } finally {
            // Stop the progress bar, whether the API call is successful or not
            setTimeout(() => {
                setLoading(false);
            }, 3000);
        }
    }

    let ApproveAndAmend;

    const handleApprovePlanData = (actionType) => {
        // e.preventDefault();

        try {
            let formDirty = false;
            if (actionType === 'Approve Plan') {

                const confirm = window.confirm(`This will Approve this Despatch Plan. Would you like to continue?, Approve Despatch Plan`);

                if (!confirm) {
                    return;
                }
                ApproveAndAmend = 'Approve';
            }
            else if (actionType === 'Amend Plan') {
                const confirm = window.confirm(`This will allow amendment for the Despatch Plan. Would you like to continue?, Amend Despatch Plan`);

                if (!confirm) {
                    return;
                }
                ApproveAndAmend = 'Amend';

                if (sAmendmentReason === '') {
                    formDirty = showError('Amendment Reason is a required field', 'error');
                }
                ApproveProcess();
                return;
            }

            if (!formDirty) {
                if (rowsConfirmedOrdersDespacth.length === 0) {
                    showError('Product items are missing. Please check the confirmation order', 'error');
                }
                else {

                    setOpenAlert(false);
                    setLoading(true);
                    ApproveProcess();
                }
            }

            setTimeout(() => {
                setLoading(false);
            }, 3000);
        } catch (error) {
            console.error('Error:', error);

        } finally {
            // Stop the progress bar, whether the API call is successful or not
            setTimeout(() => {
                setLoading(false);
            }, 3000);
        }
    }

    const ApproveProcess = () => {
        const formattedOrderDate = dayjs(orderDate).format('YYYY-MMM-DD');
        const formattedScheduleDate = dayjs(scheduleDate).format('YYYY-MMM-DD');

        const clsDespatchOrder = {
            SOrderId: iIndentID,
            SOrderConfirmationId: iConfirmationID,
            SOrderDespatchOrderId: iDespatchOrderID,
            LastUpdatedBy: LOGIN_USER,
            SRemarks: remarks,
            SScheduledDate: formattedScheduleDate,
            SDespatchOrderNo: despatchNo,
            SDespatchOrderDate: formattedOrderDate,
            SSalesOrderItems: rowsConfirmedOrdersDespacth,
            DespatchPlanSheetOrdersList: rowsReelItems,
            DespatchPlanReelOrdersList: rowsSheetItems,
            SAmendmentReason: sAmendmentReason,
        };

        const requestBody = {
            clsDespatchOrder: clsDespatchOrder,
            ApproveAndAmend: ApproveAndAmend,
            DocumentSeries: DocumentSeries,
            DocAutoFlag: true,
            ConstructedGlobalValues: {
                COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                COMPANY_ID: localStorage.getItem('companyid'),
                LOGIN_USER: LOGIN_USER
            },
            filter: {
                FinancierYear: FinancierYear,
                CompanyID: localStorage.getItem('companyid'),
                LOGIN_USER: LOGIN_USER
            },
        };

        fetch(API_ENDPOINTS.approve_amend_DespatchPlanDetails, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Unable to approve Despatch Plan')
                }
                return response.json();
            })
            .then(data => {
                showError(data.returnmsg, 'success');
                setiIndentID(requestBody.clsDespatchOrder.SOrderId);
                setiConfirmationID(requestBody.clsDespatchOrder.SOrderConfirmationId);
                setiDespatchOrderID(requestBody.clsDespatchOrder.SOrderDespatchOrderId);
                LoadDespatchPlanList();
                RefreshStatus(data.clsDespatchOrder.SOrderStatus);
            })
            .catch(error => {
                showError('Unable to approve Despatch Plan.!', 'error');
            });
    }

    const handleSavePlanData = (param) => {
        // e.preventDefault();
        try {
            let formDirty = false;

            if (!formDirty) {
                if (rowsConfirmedOrdersDespacth.length === 0) {
                    showError('Product items are missing. Please check the confirmation order', 'error');
                }
                else {
                    setOpenAlert(false);
                    setLoading(true);

                    const formattedOrderDate = dayjs(orderDate).format('YYYY-MMM-DD');
                    const formattedScheduleDate = dayjs(scheduleDate).format('YYYY-MMM-DD');

                    const clsDespatchOrder = {
                        SOrderId: iIndentID,
                        SOrderConfirmationId: iConfirmationID,
                        SOrderDespatchOrderId: iDespatchOrderID,
                        LastUpdatedBy: LOGIN_USER,
                        SRemarks: remarks,
                        SScheduledDate: formattedScheduleDate,
                        SDespatchOrderNo: despatchNo,
                        SDespatchOrderDate: formattedOrderDate,
                        SSalesOrderItems: rowsConfirmedOrdersDespacth,
                        DespatchPlanSheetOrdersList: rowsSheetItems,
                        DespatchPlanReelOrdersList: rowsReelItems,

                    };

                    const requestBody = {
                        clsDespatchOrder: clsDespatchOrder,
                        DocumentSeries: DocumentSeries,
                        DocAutoFlag: true,
                        ConstructedGlobalValues: {
                            COMPANY_FINANCIAL_YEAR_ID: FinancierYear,
                            COMPANY_ID: localStorage.getItem('companyid'),
                            LOGIN_USER: LOGIN_USER
                        },
                        filter: {
                            FinancierYear: FinancierYear,
                            CompanyID: localStorage.getItem('companyid'),
                            LOGIN_USER: LOGIN_USER
                        },
                    };

                    fetch(API_ENDPOINTS.saveDespatchPlanDetails, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(requestBody),
                    })
                        .then(response => {
                            if (!response.ok) {
                                throw new Error('Unable to save Despatch Plan')
                            }
                            return response.json();
                        })
                        .then(data => {
                            if (!data.returnmsg) {
                                showError('Unable to save or update the despatch plan', 'error');
                                return;
                            }

                            if (param) {
                                showError(data.returnmsg, 'success');
                            }

                            setbtnSaveText(data.BtnText);
                            setbtnSaveTooltip(data.BtnText, ' Plan');

                            setiIndentID(data.clsDespatchOrder.SOrderId);
                            setiConfirmationID(data.clsDespatchOrder.SOrderConfirmationId);
                            setiDespatchOrderID(data.clsDespatchOrder.SOrderDespatchOrderId);
                            LoadDespatchPlanList();
                            LoadConfirmedOrderList();

                            RefreshStatus('New');

                            if (param === false) {
                                ApproveProcess();
                            }
                        })
                        .catch(error => {
                            showError('Unable to save Despatch Plan.!', 'error');
                        });
                }
            }

            setTimeout(() => {
                setLoading(false);
            }, 3000);
        } catch (error) {
            // Handle any errors that occur during the API call
            console.error('Error:', error);

        } finally {
            // Stop the progress bar, whether the API call is successful or not
            setTimeout(() => {
                setLoading(false);
            }, 3000);
        }
    };

    // Function to get today's date
    const getToday = () => {
        return dayjs(); // Returns the current date
    };


    const [selectedStatus, setSelectedStatus] = useState('All');
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedRows_orders, setSelectedRows_orders] = useState([]);
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    const openFirst = Boolean(anchorElFirst);
    const openSecond = Boolean(anchorElSecond);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('All Order');
    const [selectedOptionFirstOrder, setSelectedOptionFirstOrder] = useState('All Order');
    const [open1, setOpen1] = useState(false);
    const [showNewToolbar, setShowNewToolbar] = useState(false);
    const [showFirstToolbar, setShowFirstToolbar] = useState(true);
    const isSelected1 = (rowId) => selectedRows.indexOf(rowId) !== -1;
    const isSelected1_order = (rowId) => selectedRows_orders.indexOf(rowId) !== -1;


    const [filters, setFilters] = useState({
        ConfirmationNo: '',
        Variety: '',
        GSM: '',
        Unit: '',
        PartyPO: '',
        ShipToArea: '',
        ShipToCity: '',
        ShipToState: '',
        ShipToCustomer: '',
        BillToCustomer: '',

    });

    const [values, setValues] = useState({
        bill_to_party: null,
        cono: "",
        prod_status: null,
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues((prev) => ({ ...prev, [name]: value }));
    };

    const handleBillToPartyChange = (value) => {
        setValues((prev) => ({ ...prev, bill_to_party: value }));
    };

    const handleProdStatusChange = (value) => {
        setValues((prev) => ({ ...prev, prod_status: value }));
    };




    const filteredData2 = filteredData_ConfirmedOrders.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.IndentStatus === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });


    const handleOpen1 = () => {
        setOpen1(true);
    };

    const handleClose1 = () => {
        setOpen1(false);
    };

    const handleSelectAllClick_Order = (event) => {
        if (event.target.checked) {
            const newSelecteds = filteredData2.map(n => n.id);
            setselectCOOrders(newSelecteds);
            return;
        }
        setselectCOOrders([]);
    };


    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };



    const handleMenuItemClickFirstForOrder = (option) => {
        setSelectedOptionFirstOrder(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'New') {
            setSelectedStatus('New');
        }
        else if (option === 'Approved') {
            setSelectedStatus('Approved');
        }
        else if (option === 'Cancelled') {
            setSelectedStatus('Cancelled');
        }
        else if (option === 'Under Amendment') {
            setSelectedStatus('Under Amendment');
        }
        else if (option === 'Processed') {
            setSelectedStatus('Processed');
        }
        else if (option === 'All Order') {
            setSelectedStatus('All');
        }

        setAnchorElFirst(null);
    };



    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        handleMenuCloseSecond();
    };


    // const handleFilterChange = (event) => {
    //     const { name, value } = event.target;
    //     setFilters({ ...filters, [name]: value });
    // };

    const handleFilterChange = (e, column) => {
        setFilters({ ...filters, [column]: e.target.value });
    };

    const handleRowCheckboxClick_Order = (event, rowId) => {
        const selectedIndex = selectedRows_orders.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedRows_orders, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedRows_orders.slice(1);
        } else if (selectedIndex === selectedRows_orders.length - 1) {
            newSelectedRows = selectedRows_orders.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedRows_orders.slice(0, selectedIndex),
                ...selectedRows_orders.slice(selectedIndex + 1),
            ];
        }

        setSelectedRows_orders(newSelectedRows);

        if (newSelectedRows.length > 0) {
            setShowNewToolbar(true); // Show new toolbar when rows are selected
            setShowFirstToolbar(false);
        }
        else {
            setShowNewToolbar(false); // Hide new toolbar when no rows are selected
            setShowFirstToolbar(true);
        }

        handleCheckboxChangeForConfirmationOrder(event, rowId)
    };



    const [isDataLoad, setDataLoad] = useState(false);

    useEffect(() => {
        if (isDataLoad) {
            if (selectedRow.length > 0) {
                handleOnCellClick(selectedRow);
                setDataLoad(true);
            }
        }
    }, [selectedRow])


    const [viewDispacth, setViewDispatch] = useState(true);

    const [selectedButtonName, setSelectedButtonName] = useState('');
    const [enableRejectParentRoll, setEnableRejectParentRoll] = useState(false);
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(false);
    const [header, setHeader] = useState(0);
    const [visibleDelete, setVisibleDelete] = useState(false);
    const [recordsPerPage, setRecordsPerPage] = useState(20); // Records per page
    const [currentPage, setCurrentPage] = useState(1);

    const handlecallProcess = (buttonName) => {

        if (buttonName === 'create') {
            handleShowDispatchPlansEntry();
        }
    }



    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const pageCount = Math.ceil(filteredData2.length / recordsPerPage);

    const uniqueValues = {
        ConfirmationNo: [...new Set(filteredData_ConfirmedOrders.map(row => row.ConfirmationNo))],
        Variety: [...new Set(filteredData_ConfirmedOrders.map(row => row.Variety))],
        GSM: [...new Set(filteredData_ConfirmedOrders.map(row => row.GSM))],
        SizeUnit: [...new Set(filteredData_ConfirmedOrders.map(row => row.SizeUnit))],
        Unit: [...new Set(filteredData_ConfirmedOrders.map(row => row.Unit))],
        PartyPO: [...new Set(filteredData_ConfirmedOrders.map(row => row.PartyPO))],
        ShipToArea: [...new Set(filteredData_ConfirmedOrders.map(row => row.ShipToArea))],
        ShipToCity: [...new Set(filteredData_ConfirmedOrders.map(row => row.ShipToCity))],
        ShipToState: [...new Set(filteredData_ConfirmedOrders.map(row => row.ShipToState))],
        ShipToCustomer: [...new Set(filteredData_ConfirmedOrders.map(row => row.ShipToCustomer))],
        BillToCustomer: [...new Set(filteredData_ConfirmedOrders.map(row => row.BillToCustomer))],
    };


    // Get the records for the current page
    const currentRecords = filteredData2.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    );


    const columns = ['', 'ConfirmationNo', 'Variety', 'GSM', 'Width', 'Length','SizeUnit', 'CORemarks', 'Remarks', 'SpecialInstruction','Unit', 'ConfirmedQty', 'AvailableStockQty', 'QtyInUnapprovedDP', 'MAProdStatus', 'ConfirmationDate', 'PartyPO', 'ShipToArea', 'ShipToCity', 'ShipToState', 'ShipToCustomer', 'BillToCustomer',];

    const autoCompleteColumns = ['ConfirmationNo', 'Variety', 'GSM', 'SizeUnit', 'Unit', 'PartyPO', 'ShipToArea', 'ShipToCity', 'ShipToState', 'ShipToCustomer', 'BillToCustomer'];

    const totals = {
        ConfirmedQty: filteredData2.reduce((sum, r) => sum + (parseFloat(r.ConfirmedQty) || 0), 0),
        AvailableStockQty: filteredData2.reduce((sum, r) => sum + (parseFloat(r.AvailableStockQty) || 0), 0),
        QtyInUnapprovedDP: filteredData2.reduce((sum, r) => sum + (parseFloat(r.QtyInUnapprovedDP) || 0), 0),
    };





    return (<>
        <CssBaseline />

        {viewDispacth && (<>
            {/* {viewCreateDispatchPlan && (
                <>
                    <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                        <Toolbar>
                           
                            <Button
                                color="secondary"
                                onClick={handleMenuClickFirst}
                                endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                                sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                            >
                                {selectedOptionFirst}
                            </Button>
                            <Menu
                                anchorEl={anchorElFirst}
                                open={openFirst}
                                onClose={handleMenuCloseFirst}
                            >
                                <MenuItem onClick={() => handleMenuItemClickFirstForOrder('All Order')}>All Order</MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickFirstForOrder('New')}>New</MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickFirstForOrder('Approved')}>Approved</MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickFirstForOrder('Cancelled')}>Cancelled</MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickFirstForOrder('Under Amendment')}>Under Amendment</MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickFirstForOrder('Processed')}>Processed</MenuItem>
                            </Menu>

                            
                            <Box sx={{ flexGrow: 1 }} />

                            <Tooltip title="Back to Despatch Plan List [Alt + P]" onClick={handleCallBack}>
                                <Button variant='contained' size="small" color="secondary" sx={{ textTransform: 'none' }} endIcon={<List />} onClick={handleCallBack}>
                                    Despatch Plan List
                                </Button>
                            </Tooltip>

                            <Tooltip title="Create New Despatch Plan [Alt + N]" >
                                {isVisiblebtnCreateDespatchPlan && (
                                    <Button size="small" variant="contained" onClick={handleShowDispatchPlansEntry} color="success" startIcon={<AddIcon />} sx={{ ml: 2, textTransform: 'none' }}>Create</Button>
                                )}
                            </Tooltip>

                            <Tooltip title="Add Orders to Existing Plan [Alt + N]" >
                                {isVisiblebtnAddSelectedCO && (
                                    <Button variant='contained' style={{ backgroundColor: '#1769aa', textTransform: 'none' }} size='small' startIcon={<AddIcon />} onClick={handleShowDispatchPlansEntry}>
                                        Add Selected CO's
                                        
                                    </Button>
                                )}
                            </Tooltip>

                           
                            <IconButton
                                size="small"
                                aria-label="menu"
                                sx={{ ml: 2 }}
                                onClick={handleMenuClickSecond}
                            >
                                <MoreVertIcon />
                            </IconButton>

                            <Menu
                                anchorEl={anchorElSecond}
                                open={openSecond}
                                onClose={handleMenuCloseSecond}
                            >
                                <MenuItem onClick={() => handleMenuItemClickSecond('Import Items')}>
                                    <ListItemIcon>
                                        <ImportExportIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Import Items" />
                                </MenuItem>
                                <MenuItem onClick={() => handleMenuItemClickSecond('Export Items')}>
                                    <ListItemIcon>
                                        <FileDownloadIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Export Items" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Export Current View')}>
                                    <ListItemIcon>
                                        <ViewColumnIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Export Current View" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                    <ListItemIcon>
                                        <ListAltIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Preference " />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                    <ListItemIcon>
                                        <RefreshIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Refresh List" />
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>
                                    <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                        Reset Columns Width
                                    </Button>
                                </MenuItem>
                            </Menu>

                            <IconButton
                                size="small"
                                aria-label="menu"
                                sx={{ mr: 1, ml: 1 }}
                                onClick={handleMenuClickSecond}
                            >
                                <HelpIcon />
                            </IconButton>

                            <div>
                                <IconButton onClick={handleCallBack}>
                                    <Close fontSize="inherit" style={{ color: "#2196F3" }} />
                                </IconButton>
                            </div>
                        </Toolbar>
                    </AppBar>
                    <CustomSnackbar open={snackbarOpen} message={alertMessage} onClose={handleSnackbarClose} type={alertsevierity} />
                </>
            )} */}

            {viewCreateDispatchPlan && (
                <form onSubmit={handleSubmitConfirmationOrder}>
                    <Box>

                        <>
                            <COActionMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} handlecallProcess={handlecallProcess} enableRejectParentRoll={enableRejectParentRoll} title={header} callback={handleCallBack} saveButtonDisabled={saveButtonDisabled} visibleDelete={visibleDelete} header={header} />
                            <Divider />
                        </>
                        <CustomSnackbar open={snackbarOpen} message={alertMessage} onClose={handleSnackbarClose} type={alertsevierity} />
                        {/* <DateRangePicker fromDate={FromCODate} toDate={ToCODate} onFromChange={(date) => handleFromCODate(date)} onToChange={(date) => handleToCODate(date)} autoFocus /> */}
                        {/*<CODetailFilter fromDate={FromCODate} toDate={ToCODate} onFromChange={(date) => handleFromCODate(date)} onToChange={(date) => handleToCODate(date)} autoFocus />*/}

                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                p: 1,
                                ml: "15px",
                                mr: "15px",
                                borderRadius: 1,
                                backgroundColor: colors.primary[400],
                                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                flexWrap: "wrap",
                            }}
                        >
                            {/* ORDER FROM DATE */}
                            <Box sx={{ width: 160 }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="Order From"
                                        value={dayjs(FromDate)}
                                        // onChange={(date) => handleDateFilterChange("from", date)}
                                        onChange={(date) => handleFromCODate(date)}
                                        format="DD-MMM-YYYY"
                                        slotProps={{ textField: { size: "small", color: "secondary" } }}
                                    />
                                </LocalizationProvider>
                            </Box>

                            {/* ORDER TO DATE */}
                            <Box sx={{ width: 160 }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="Order To"
                                        value={dayjs(ToDate)}
                                        // onChange={(date) => handleDateFilterChange("to", date)}
                                        onChange={(date) => handleToCODate(date)}
                                        format="DD-MMM-YYYY"
                                        slotProps={{ textField: { size: "small", color: "secondary" } }}
                                    />
                                </LocalizationProvider>
                            </Box>

                            {/* BILL TO PARTY AUTOCOMPLETE */}
                            <Autocomplete
                                size="small"
                                sx={{ width: 250, borderRadius: 1 }}
                                options={billToPartyList}
                                getOptionLabel={(option) => option.party_name}
                                value={values.bill_to_party}
                                onChange={(e, value) => handleBillToPartyChange(value)}
                                renderInput={(params) => (
                                    <TextField color="secondary" {...params} label="Bill To Party" />
                                )}
                            />


                            {/* CONO / DPNO */}
                            <TextField
                                label="CONO / DPNO"
                                size="small"
                                name="cono"
                                color="secondary"
                                value={values.cono}
                                onChange={handleInputChange}
                                sx={{ width: 180, borderRadius: 1 }}
                            />


                            {/* PRODUCTION STATUS AUTOCOMPLETE */}
                            <Autocomplete
                                size="small"
                                sx={{ width: 140, borderRadius: 1 }}
                                options={["Pending", "In-Process", "Completed", "Cancelled"]}
                                value={values.prod_status}
                                onChange={(e, value) => handleProdStatusChange(value)}
                                renderInput={(params) => (
                                    <TextField color="secondary" {...params} label="Prod. Status" />
                                )}
                            />


                            {/* SEARCH BUTTON */}
                            <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                startIcon={<SearchIcon />}
                                sx={{
                                    height: 33,
                                    px: 2,
                                    fontWeight: 600,
                                    textTransform: "none",
                                    borderRadius: 2,
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                }}
                                onClick={LoadConfirmedOrderList}
                            >
                                Search
                            </Button>
                        </Box>
                        <ResponsiveBox colors={colors} customMaxHeight={{ xs: '72vh', sm: '72vh', md: '74vh', lg: '85vh', xl: '100vh' }}>
                            <CustomTableContainer colors={colors}>
                                <TableContainer>
                                    <Table size="small">
                                        <TableHead sx={{ backgroundColor: colors.primary[400] }}>
                                            <TableRow>
                                                <TableCell>
                                                    <Checkbox
                                                        size="small"
                                                        style={{ color: "secondary" }}
                                                        indeterminate={selectCOOrders.length > 0 && selectCOOrders.length < filteredData2.length}
                                                        checked={selectCOOrders.length === filteredData2.length}
                                                        onChange={handleSelectAllClick_Order}
                                                    />
                                                </TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>CO NO</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>VARIETY</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>GSM</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>WIDTH</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>LENGTH</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>SIZE UNIT</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>CO REMARKS</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>LINE REMARKS</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>SPL.INSTRUCTION</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>UNIT</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>CO QTY</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>AVAILABLE STOCK QTY</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>UN APPROVED DP QTY</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>MA PROD.STATUS</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>CO DATE</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>PO NO</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>SHIP-TO-AREA</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>SHIP-TO-CITY</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>SHIP-TO-STATE</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>SHIP-TO-PARTY</TableCell>
                                                <TableCell sx={{ textAlign: 'center' }}>BILL-TO-PARTY</TableCell>

                                                {/* <TableCell>
                                                    <IconButton onClick={handleOpen}>
                                                        <SearchIcon style={{ fontSize: "16px" }} />
                                                    </IconButton>
                                                    <Modal
                                                        open={open}
                                                        onClose={handleClose}
                                                        aria-labelledby="modal-modal-title"
                                                        aria-describedby="modal-modal-description"
                                                    >
                                                        <Box sx={{ position: 'absolute', top: '50%', left: '50%', bgcolor: 'background.paper', transform: 'translate(-50%, -50%)', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                            <TextField
                                                                label="CO NO"
                                                                name="code"
                                                                value={filters.code}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                                size="small"
                                                                color="secondary"
                                                            />
                                                            <TextField
                                                                label="VARIETY"
                                                                name="description"
                                                                value={filters.description}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                                size="small"
                                                                color="secondary"
                                                            />
                                                            <TextField
                                                                label="GSM"
                                                                name="warehouse_type"
                                                                value={filters.warehouse_type}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                                size="small"
                                                                color="secondary"
                                                            />
                                                            <TextField
                                                                label="WIDTH"
                                                                name="environment_type"
                                                                value={filters.environment_type}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                                size="small"
                                                                color="secondary"
                                                            />

                                                            <TextField
                                                                label="LENGTH"
                                                                name="environment_type"
                                                                value={filters.environment_type}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                                size="small"
                                                                color="secondary"
                                                            />

                                                            <TextField
                                                                label="SIZE UNIT"
                                                                name="environment_type"
                                                                value={filters.environment_type}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                                size="small"
                                                                color="secondary"
                                                            />

                                                            <TextField
                                                                label="CO REMARKS"
                                                                name="environment_type"
                                                                value={filters.environment_type}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                                size="small"
                                                                color="secondary"
                                                            />

                                                            <TextField
                                                                label="LINE REMARKS"
                                                                name="environment_type"
                                                                value={filters.environment_type}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                                size="small"
                                                                color="secondary"
                                                            />

                                                            <TextField
                                                                label="SPL.INSTRUCTION"
                                                                name="environment_type"
                                                                value={filters.environment_type}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                                size="small"
                                                                color="secondary"
                                                            />

                                                            <TextField
                                                                label="UNIT"
                                                                name="environment_type"
                                                                value={filters.environment_type}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                                size="small"
                                                                color="secondary"
                                                            />

                                                            <TextField
                                                                label="CO QTY"
                                                                name="environment_type"
                                                                value={filters.environment_type}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                                size="small"
                                                                color="secondary"
                                                            />

                                                            <TextField
                                                                label="AVAILABLE STOCK QTY"
                                                                name="environment_type"
                                                                value={filters.environment_type}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                                size="small"
                                                                color="secondary"
                                                            />

                                                            <TextField
                                                                label="UN APPROVED DP QTY"
                                                                name="environment_type"
                                                                value={filters.environment_type}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                                size="small"
                                                                color="secondary"
                                                            />


                                                            <TextField
                                                                label="MA PROD.STATUS"
                                                                name="environment_type"
                                                                value={filters.environment_type}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                                size="small"
                                                                color="secondary"
                                                            />

                                                            <TextField
                                                                label="CO DATE"
                                                                name="environment_type"
                                                                value={filters.environment_type}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                                size="small"
                                                                color="secondary"
                                                            />

                                                            <TextField
                                                                label="PO NO"
                                                                name="environment_type"
                                                                value={filters.environment_type}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                                size="small"
                                                                color="secondary"
                                                            />

                                                            <TextField
                                                                label="SHIP TO AREA"
                                                                name="environment_type"
                                                                value={filters.environment_type}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                                size="small"
                                                                color="secondary"
                                                            />





                                                            <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                                Apply Filter
                                                            </Button>
                                                        </Box>
                                                    </Modal>
                                                </TableCell> */}
                                            </TableRow>


                                            <TableFilterRow
                                                columns={columns}
                                                filters={filters}
                                                handleFilterChange={handleFilterChange}
                                                uniqueValues={uniqueValues}
                                                autoCompleteColumns={autoCompleteColumns}
                                            />
                                        </TableHead>
                                        <TableBody>
                                            {currentRecords.map((row, index) => (

                                                <TableRow key={row.id} sx={{
                                                    backgroundColor: index % 2 === 0 ?
                                                        theme.palette.background.default : alpha(theme.palette.action.hover, 0.04),
                                                }}>
                                                    <TableCell>
                                                        <Checkbox
                                                            size="small"
                                                            checked={isSelected1_order(row.id)}
                                                            onChange={(event) => handleRowCheckboxClick_Order(event, row.id)}
                                                        />
                                                    </TableCell>

                                                    <TableCell sx={{ textAlign: 'center' }}>
                                                        <span
                                                            style={{ textAlign: 'center', }}
                                                        // onClick={() => handleCallEdit(row)}
                                                        >
                                                            {row.ConfirmationNo}
                                                        </span>
                                                    </TableCell>

                                                    <TableCell sx={{ textAlign: 'center' }}>{row.Variety}</TableCell>
                                                    <TableCell sx={{ textAlign: 'right' }}>{row.GSM}</TableCell>
                                                    <TableCell sx={{ textAlign: 'right' }}>{row.Width}</TableCell>
                                                    <TableCell sx={{ textAlign: 'right' }}>{row.Length}</TableCell>
                                                    <TableCell sx={{ textAlign: 'center' }}>{row.SizeUnit}</TableCell>
                                                    <TableCell sx={{ textAlign: 'left' }}>{row.CORemarks}</TableCell>
                                                    <TableCell sx={{ textAlign: 'left' }}>{row.Remarks}</TableCell>
                                                    <TableCell sx={{ textAlign: 'left' }}>{row.SpecialInstruction}</TableCell>
                                                    <TableCell sx={{ textAlign: 'center' }}>{row.Unit}</TableCell>
                                                    <TableCell sx={{ textAlign: 'right' }}>{row.ConfirmedQty}</TableCell>
                                                    <TableCell sx={{ textAlign: 'right' }}>{row.AvailableStockQty}</TableCell>
                                                    <TableCell sx={{ textAlign: 'right' }}>{row.QtyInUnapprovedDP}</TableCell>
                                                    <TableCell sx={{ textAlign: 'center' }}>{row.MAProdStatus}</TableCell>
                                                    <TableCell sx={{ textAlign: 'center' }}>
                                                        {dayjs(row.ConfirmationDate).format("DD-MMM-YYYY")}
                                                    </TableCell>
                                                    <TableCell sx={{ textAlign: 'center' }}>{row.PartyPO}</TableCell>
                                                    <TableCell sx={{ textAlign: 'center' }}>{row.ShipToArea}</TableCell>
                                                    <TableCell sx={{ textAlign: 'center' }}>{row.ShipToCity}</TableCell>
                                                    <TableCell sx={{ textAlign: 'center' }}>{row.ShipToState}</TableCell>
                                                    <TableCell sx={{ textAlign: 'center' }}>{row.ShipToCustomer}</TableCell>
                                                    <TableCell sx={{ textAlign: 'center' }}>{row.BillToCustomer}</TableCell>
                                                </TableRow>
                                            ))}

                                            <TableRow sx={{ backgroundColor: colors.primary[400], height: 10 }}>
                                                <TableCell colSpan={11} sx={{  textAlign: 'right' }}>TOTAL : </TableCell>
                                                <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.ConfirmedQty.toFixed(1)}</TableCell>
                                                <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.AvailableStockQty.toFixed(1)} KG</TableCell>
                                                <TableCell sx={{ textAlign: "right", fontWeight: 'bold' }}>{totals.QtyInUnapprovedDP.toFixed(1)}</TableCell>

                                                <TableCell /> {/* SIZE1 */}
                                                <TableCell /> {/* SIZE2 */}
                                                <TableCell /> {/* REPULP /HOLD */}
                                                <TableCell /> {/* REMARKS */}
                                                <TableCell /> {/* GRADE */}
                                                <TableCell /> {/* GRADE */}
                                                <TableCell /> {/* GRADE */}
                                                <TableCell /> {/* GRADE */}


                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                    {/* table footer value */}
                                </TableContainer>

                            </CustomTableContainer>

                            {/* // new design */}


                        </ResponsiveBox>
                        <CustomPagination pageCount={pageCount} currentPage={currentPage} onPageChange={handlePageChange} />



                    </Box>
                </form>
            )}



            <DespatchActionMenu
                isVisible={isVisible_commanButtons}
                fromModule={fromModule}
                headerText={headerDespatchplan}
                btnSaveUpdate={btnSaveUpdate}
                btnSaveTooltip={btnSaveTooltip}
                btnSaveText={btnSaveText}
                btnCancel={btnCancel}
                btnApprove={btnApprove}
                btnAmendment={btnAmendment}
                btnPrint={btnPrint}
                handleBack={handleBackTofromDespacthPlanEntry}
                handleSave={() => handleSavePlanData(true)}
                handleCancel={handleCancel}
                handleApprove={handleApprovePlanData}
                handleAmendment={handleApprovePlanData}
                handlePrint={handleViewReport}
            />



            {isVisible_commanButtons && (
                <Divider style={{ marginBottom: "1px" }} />
            )}

            {viewCreateDispatchPlanEntry && (
                <> <CustomSnackbar open={snackbarOpen} message={alertMessage} onClose={handleSnackbarClose} type={alertsevierity} />
                    <Box m='10px'>
                        <Grid container spacing={2} padding={1} mt={2}>
                            <Grid item xs={12}>
                                <Grid container spacing={2} alignItems="center">
                                    {/* CO No */}
                                    <Grid item xs={12} sm={2} xl={1}>
                                        <Typography variant="subtitle1">Despatch Plan No Series</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={4} xl={2}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            color="secondary"
                                            label="Despatch Plan No Series"
                                            value={despatchNo}
                                            onChange={(e) => setDespatchNo(e.target.value)}
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={2} xl={1.5}>
                                        <Typography variant="subtitle1">Despatch Plan No</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={4} xl={2}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                              color="secondary"
                                            label="Despatch Plan No"
                                            value={dispatchPlanNo}
                                            onChange={(e) => setDispatchPlanNo(e.target.value)}
                                            InputProps={{ readOnly: true }}
                                            disabled={true}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            {/* Example: Bill to Customer */}
                            <Grid item xs={12}>
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item xs={12} sm={2} xl={1}>
                                        <Typography variant="subtitle1">Order Date</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={4} xl={2}>
                                        <FormControl fullWidth size="small">
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    label="Order Date"
                                                    value={dayjs(orderDate)}
                                                    format="DD-MMM-YYYY"
                                                    onChange={handlerOrderDate}
                                                    minDate={getToday()}
                                                    slotProps={{
                                                        textField: { size: "small", variant: "outlined" ,color:"secondary"  },
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>

                                    {/* Ship to Customer */}
                                    <Grid item xs={12} sm={2} xl={1.5}>
                                        <Typography variant="subtitle1">Schedule Date</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={4} xl={2}>
                                        <FormControl fullWidth size="small">
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    label="Schedule Date"
                                                    format="DD-MMM-YYYY"
                                                    value={dayjs(scheduleDate)}
                                                    onChange={handleScheduleDate}
                                                    slotProps={{
                                                        textField: { size: "small", variant: "outlined",color:"secondary"  },
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item xs={12} sm={2} xl={1}>
                                        <Typography variant="subtitle1">Remarks</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={4} xl={2}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                              color="secondary"
                                            variant="outlined"
                                            label="Remarks"
                                            value={remarks}
                                            onChange={(e) => SetRemarks(e.target.value)}
                                        />
                                    </Grid>

                                    {visibleAmendmentReason && (
                                        <>
                                            {/* Ship to Customer */}
                                            <Grid item xs={12} sm={2} xl={1.5}>
                                                <Typography variant="subtitle1">Amendment Reason</Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={4} xl={2}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                      color="secondary"
                                                    required
                                                    error={!!amendReasonError}
                                                    helperText={amendReasonError}
                                                    variant="outlined"
                                                    label="Amendment Reason"
                                                    value={sAmendmentReason}
                                                    onChange={handleSelectAmendmentReason}
                                                />
                                            </Grid>
                                        </>
                                    )}
                                </Grid>
                            </Grid>


                            {isVisible_cancelDetail && (
                                <>
                                    <Grid item xs={12}>
                                        <Grid container spacing={2} alignItems="center">
                                            <Grid item xs={12} sm={2} xl={1}>
                                                <Typography variant="subtitle1"> Cancel Details</Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={4} xl={2}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    variant="outlined"
                                                    color="error"
                                                    label="Cancel Reason"
                                                    value={reason}
                                                    onChange={handleEnterReason}
                                                    error={!!ReasonError}
                                                    helperText={ReasonError}
                                                    required
                                                />
                                            </Grid>


                                            {/* Ship to Customer */}
                                            <Grid item xs={12} sm={2} xl={1.5}>
                                                <Typography variant="subtitle1">Cancel Date</Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={4} xl={2}>
                                                <FormControl
                                                    fullWidth
                                                    size="small"
                                                    required
                                                    error={!!DateError}
                                                >
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            label="Cancel Date"
                                                            value={dayjs(cancelDate)}
                                                              format="DD-MMM-YYYY"
                                                            onChange={handleDateChange}
                                                            slotProps={{
                                                                textField: { size: "small",color:"error", variant: "outlined" },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                    {DateError && <FormHelperText>{DateError}</FormHelperText>}
                                                </FormControl>
                                            </Grid>


                                        </Grid>
                                    </Grid>

                                </>)}


                        </Grid>

                        <Divider sx={{ mt: 2 }} />

                        <ConfirmationOrderItems rowsConfirmedOrdersDespacth={rowsConfirmedOrdersDespacth} loading={loading} handleOn_OrderItemsCellClick={handleOn_OrderItemsCellClick} />
                        <PlannedQtySummaryCard plannedQtyData={plannedQtyData} />

                    </Box>


                </>

            )}

            {viewDispatchItem && (
                <Box m='0px'>
                    {open && (
                        <div style={{
                            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backdropFilter: 'blur(2px)', // Adjust the blur intensity
                            zIndex: 1000, // Adjust the z-index to be above other content
                        }}
                        ></div>
                    )}

                    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md" >
                        <DialogContent padding={0} style={{ padding: '0px', margin: '0px', backgroundColor: theme.palette.background.default }}>
                            <Card style={{ borderRadius: '5px 5px 5px 5px', backgroundColor: "transparent", marginBottom: "0px", marginTop: "0px" }}>
                                <Box
                                    sx={{
                                        backgroundColor: colors.primary[500],
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#FFFFFF', // Adjust font color based on theme mode
                                    }}
                                >
                                    <Typography variant="h5" padding={1}>Select the Items for Despatch Plan</Typography>

                                    <Tooltip title="Close" onClick={handleClose}>
                                        <IconButton>
                                            <CancelIcon style={{ color: "#ef5350" }} />
                                        </IconButton>
                                    </Tooltip>
                                </Box>

                                <CardContent style={{ padding: 2, borderRadius: '5px 5px 5px 5px', backgroundColor: "transparent", }}>
                                    <Box
                                        display="grid"
                                        gridTemplateColumns="repeat(20, 1fr)"
                                        gridAutoRows="500px"
                                        gap="0px"
                                    >
                                        <Box
                                            gridColumn="span 20"
                                            display="flex"
                                            alignItems="center"
                                            justifyContent="center"
                                            sx={{
                                                "& .custom-header": {
                                                    fontWeight: 'bold',  // set bold font
                                                    fontSize: '0.85rem',  // adjust font size                                 
                                                },
                                                borderRadius: '15px 15px 15px 15px',
                                                "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                                                    color: `${colors.grey[100]} !important`,
                                                },
                                                "& .MuiCheckbox-root": {
                                                    color: `${colors.greenAccent[200]} !important`,
                                                },
                                            }}
                                        >
                                            {isVisibleReelItem && (
                                                <DataGrid
                                                    style={{ marginTop: '0px' }}
                                                    rows={rowsReelItemsFiltered || []}
                                                    columns={columnsReelItems}
                                                    // checkboxSelection
                                                    rowHeight={30}
                                                    pageSize={5}
                                                    slots={{ toolbar: GridToolbar }}
                                                    slotProps={{
                                                        toolbar: {
                                                            showQuickFilter: true,
                                                        },
                                                    }}

                                                />
                                            )}

                                            {isVisibleSheetItem && (
                                                <DataGrid
                                                    style={{ marginTop: '0px' }}
                                                    rows={rowsSheetItemsFiltered || []}
                                                    columns={columnsSheetItems}
                                                    // checkboxSelection
                                                    rowHeight={30}
                                                    pageSize={5}
                                                    slots={{ toolbar: GridToolbar }}
                                                    slotProps={{
                                                        toolbar: {
                                                            showQuickFilter: true,
                                                        },
                                                    }}
                                                />
                                            )}
                                        </Box>
                                    </Box>
                                </CardContent>
                            </Card>
                        </DialogContent>
                    </Dialog>
                </Box>
            )}

        </>
        ) || (<>

            {showReport && (
                <DispatchPlanReport orderData={reportRequestBody} handleBackToSalesOrderDetails={handleCloseReport} totals={reportRequestBody} />
            )}

        </>)}



    </>)
}
export default CreateDispatch